import React from 'react';
import { useRouter } from 'next/router';
import styles from '../../styles/blog/categoryFilter.module.scss';

export default function CategoryFilter({ categories = [], activeCategory }) {
    const router = useRouter();

    const handleFilter = (slug) => {
        if (slug) {
            router.push(`/blog?category=${slug}`, undefined, { shallow: false });
        } else {
            router.push('/blog', undefined, { shallow: false });
        }
    };

    return (
        <div className={styles.filterBar}>
            <button
                className={`${styles.pill} ${!activeCategory ? styles.active : ''}`}
                onClick={() => handleFilter(null)}
            >
                All
            </button>
            {categories.map((cat) => (
                <button
                    key={cat.slug}
                    className={`${styles.pill} ${activeCategory === cat.slug ? styles.active : ''}`}
                    onClick={() => handleFilter(cat.slug)}
                >
                    {cat.name}
                </button>
            ))}
        </div>
    );
}
